import React, { useContext, useState, useEffect } from "react";
import {
  Tab,
  Form,
  FormGroup,
  Input,
  TextArea,
  Grid,
  Label,
  Container
} from "semantic-ui-react";
import WorkOrderStore from "../../../../app/stores/workorderStore";
import UserAuthStore from "../../../../app/stores/userauthStore"
import { observer } from "mobx-react-lite";
import { IWorkorder } from "../../../../app/models/workorder";
import WorkOrderSORSGrid from "../wo_sor_grid/WorkOrderSORSGrid";
import WorkOrderEngineerNotes from "../wo_engineer_notes/WorkOrderEngineerNotes";
import WorkOrderVarHistory from "../wo_varhistory/WorkOrderVarHistory";
import WorkOrderVariations from "../wo_variations/WorkOrderVariations";
import AppointmentGrid from "../wo_appointments/AppointmentGrid";

//ADD230608 - check document tab
import WorkOrderDocumentGrid from "../wo_document_grid/WorkOrderDocumentGrid_woad";
//ADD230614 - check clientnote tab
import WorkOrderClientnoteGrid from "../wo_clientnote_grid/WorkOrderClientnoteGrid_woad";

interface IProps {}

const getPanes = (wo: IWorkorder) => {
  return [
    {
      menuItem: "Details",
      render: () => (
        <Tab.Pane attached={false}>
          <Container>
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <Form widths="equal">
                    <FormGroup>
                      <Form.Field>
                        <Input
                          value={wo.JobNo}
                          label="Job No"
                          size="mini"
                          readonly
                          placeholder="Job No"
                          fluid
                        />
                      </Form.Field>
                      <Form.Field>
                        <Input
                          value={wo.ClientRef}
                          label="Client Ref"
                          size="mini"
                          readonly
                          placeholder="Client Ref"
                          fluid
                        />
                      </Form.Field>
                    </FormGroup>

                    {/* <FormGroup>
                      <Form.Field>
                        <Input
                          value={wo.JobStatus}
                          label="Status"
                          size="mini"
                          readonly
                          placeholder="Status"
                          fluid
                        />
                      </Form.Field>
                      <Form.Field>
                        <Input
                          value={wo.JobSubStatus}
                          label="Sub Status"
                          size="mini"
                          readonly
                          placeholder="Sub Status"
                          fluid
                        />
                      </Form.Field>
                    </FormGroup> */}

                    <FormGroup>
                      <Form.Field>
                        <Input
                          label="Priority"
                          value={wo.Priority}
                          size="mini"
                          readonly
                          placeholder="Priority"
                          fluid
                        />
                      </Form.Field>
                      <Form.Field>
                        <Input
                          fluid
                          label="Value"
                          readonly
                          size="mini"
                          value={wo.JobValue}
                          placeholder="Value"
                        />
                      </Form.Field>
                    </FormGroup>
                    <FormGroup>
                        <Form.Field>
                          <Input
                            label="Cause"
                            value={wo.Cause}
                            size="mini"
                            readonly
                            placeholder="Cause"
                            fluid
                          />
                        </Form.Field>
                       
                      </FormGroup>
                    <FormGroup>
                      <Form.Field>
                        <Label>Site Address</Label>
                        <TextArea readonly value={wo.Address} />
                      </Form.Field>
                    </FormGroup>
                  </Form>
                </Grid.Column>
                <Grid.Column>
                  <Form widths="equal">
                    <FormGroup>
                      <Form.Field>
                        <Label>Job Summary</Label>
                        <TextArea readonly rows="10" value={wo.JobSummary} />
                      </Form.Field>
                    </FormGroup>
                  </Form>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Tab.Pane>
      )
    },
    {
      menuItem: "SORS",
      render: () => (
        <Tab.Pane attached={false}>
          <WorkOrderSORSGrid />
        </Tab.Pane>
      )
    },
    {
      menuItem: "Engineer Notes",
      render: () => (
        <Tab.Pane attached={false}>
          <WorkOrderEngineerNotes />
        </Tab.Pane>
      )
    },
    {
      menuItem: "Variation History",
      render: () => (
        <Tab.Pane attached={false}>
          <WorkOrderVarHistory />
        </Tab.Pane>
      )
    },

    {
      menuItem: "Variation Request",
      render: () => (
        <Tab.Pane attached={false}>
          <WorkOrderVariations />
        </Tab.Pane>
      )
    },
    {
      menuItem: "Appointments",
      render: () => (
        <Tab.Pane attached={false}>
          <AppointmentGrid/>
        </Tab.Pane>
      )
    },
  ];
};

const panes = [
  {
    menuItem: "Details",
    render: () => (
      <Tab.Pane attached={false}>
        <Grid>
          <Grid.Row columns={2}>
            <Grid.Column>
              <Form widths="equal">
                <FormGroup>
                  <Form.Field>
                    <Input
                      label="Job No"
                      size="mini"
                      placeholder="Job No"
                      fluid
                    />
                  </Form.Field>
                  <Form.Field>
                    <Input
                      label="Client Ref"
                      size="mini"
                      placeholder="Client Ref"
                      fluid
                    />
                  </Form.Field>
                </FormGroup>

                <FormGroup>
                  {/* <Form.Field>
                    <Input
                      label="Status"
                      size="mini"
                      placeholder="Status"
                      fluid
                    />
                  </Form.Field> */}
                  <Form.Field>
                    <Input
                      label="Sub Status"
                      size="mini"
                      placeholder="Sub Status"
                      fluid
                    />
                  </Form.Field>
                </FormGroup>
                <FormGroup>
                  <Form.Field>
                    <Input
                      label="Priority"
                      size="mini"
                      placeholder="Priority"
                      fluid
                    />
                  </Form.Field>
                  <Form.Field>
                    <Input
                      fluid
                      label="Value"
                      size="mini"
                      placeholder="Value"
                    />
                  </Form.Field>
                </FormGroup>
                <FormGroup>
                  <Form.Field>
                    <Label>Site Address</Label>
                    <TextArea />
                  </Form.Field>
                </FormGroup>
              </Form>
            </Grid.Column>
            <Grid.Column>
              <Form widths="equal">
                <FormGroup>
                  <Form.Field>
                    <Label>Job Summary</Label>
                    <TextArea rows="10" />
                  </Form.Field>
                </FormGroup>
              </Form>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Tab.Pane>
    )
  },
  {
    menuItem: "SORS",
    render: () => <Tab.Pane attached={false}>SORS</Tab.Pane>
  },
  {
    menuItem: "Engineer Notes",
    render: () => <Tab.Pane attached={false}>Engineer Notes</Tab.Pane>
  },
  {
    menuItem: "Variation History",
    render: () => <Tab.Pane attached={false}>Variation History</Tab.Pane>
  }
  ,
  {
    menuItem: "Variation Request",
    render: () => <Tab.Pane attached={false}>Variation Request</Tab.Pane>
  },
  {
    menuItem: "Appointments",
    render: () => <Tab.Pane attached={false}>Appointments</Tab.Pane>
  }
];

//ADD 230608 for origin document and notes tab 
const getOriginPanes = (wo: IWorkorder) => {
  var OriginPanes = getPanes(wo);
  OriginPanes.push({
    menuItem: "Documents",
    render: () => (
       <Tab.Pane attached={false}><WorkOrderDocumentGrid  /></Tab.Pane>
     )
     });
  OriginPanes.push({
    menuItem: "Notes",
    render: () => (
         <Tab.Pane attached={false}><WorkOrderClientnoteGrid  /></Tab.Pane>
       )
       });    
  return OriginPanes;
  };

//ADD 251023 for peabody document tab
const getPeabodyPanes = (wo: IWorkorder) => {
  var PeabodyPanes = getPanes(wo)
  PeabodyPanes.push({
    menuItem: "Documents",
    render: () => (
       <Tab.Pane attached={false}><WorkOrderDocumentGrid  /></Tab.Pane>
    )
    });
    
  return PeabodyPanes;
  };

//ADD 230608 for origin document tab
var OriginPanes = panes
OriginPanes.push({
  menuItem: "Documents",
  render: () => <Tab.Pane attached={false}>Documents</Tab.Pane>
});
OriginPanes.push({
  menuItem: "Notes",
  render: () => <Tab.Pane attached={false}>Notes</Tab.Pane>
});

const WorkOrderDetails: React.FC<IProps> = () => {
  //ADD 230608 for checking client
  let sessionObj = JSON.parse(sessionStorage.getItem("sessionObj")!) 

  const userauthStore = useContext(UserAuthStore);
  const workorderStore = useContext(WorkOrderStore);

  const { selectedWorkOrder: workorder } = workorderStore;
  const [tabContent, setTabContent] = useState([{}]);


  useEffect(() => {
    userauthStore.HydrateAuthState();
   }, [userauthStore]);
 

  useEffect(() => {
    var cli = sessionObj.Client.Name;
    console.log('client::',cli )
    if (workorder != null) {
      //CHANGE 230608 for origin document tab
      if(cli == "Origin Housing" || cli == "Origin"){
        console.log('workorder::',workorder)
        setTabContent(getOriginPanes(workorder));
      } else if(cli == "Peabody New Contract 2024" || cli == "Peabody"){
        setTabContent(getPeabodyPanes(workorder))

      } else{
        setTabContent(getPanes(workorder));
      }
    } else {
      setTabContent(panes);
    }
  }, [workorder]);

  return (
    <div>
   
      <Tab
        menu={{ fluid: true, vertical: true, tabular: false }}
        panes={tabContent}
      />
    </div>
  );
};

export default observer(WorkOrderDetails);
